export default __webpack_public_path__ + "static/media/hemorragea_cerebral_espontanea.8a2fb5c1.pdf";